import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TegelModule } from '@scania/tegel-angular-17';
import { DialogService } from 'ng2-bootstrap-modal';
import { ToastrService } from 'ngx-toastr';
import { UtilService } from 'src/app/shared/architecture/services/util.service';
import { ConfirmComponent } from 'src/app/shared/modal/confirm/confirm.component';
import { FollowupReasons } from 'src/app/shared/models/followupReasons.model';
import { FrontOfficesService } from 'src/app/shared/services/core/front-offices.service';

@Component({
  selector: 'app-motivo-fup',
  imports: [TegelModule, CommonModule],
  templateUrl: './motivo-fup.component.html',
  styleUrl: './motivo-fup.component.scss'
})
export class MotivoFupComponent implements OnInit {
  saveFollowupReasonForm!: FormGroup;
  followupReasons: FollowupReasons[];
  pageFollowReason = 1;
  searchText = '';
  order = "id";

  constructor(private utilService: UtilService,
              private formBuilder: FormBuilder,
              private frontofficesServices: FrontOfficesService,
              private dialogService: DialogService,
              private toastr: ToastrService) {
                this.followupReasons = [];
  }

  ngOnInit(): void {
    this.saveFollowupReasonForm = this.formBuilder.group({
      description: ['', Validators.required]
    });

    this.getAllReasons();
  }

  deleteFollowupReasons(id: any, description: any) {
    this.dialogService.addDialog(ConfirmComponent, {
      title: 'Confirmar',
      message: 'Deseja excluir o motivo ' + description + ' ?'
    }, this.utilService.getModalOptions()).subscribe((resultConfirm) => {
      if (resultConfirm.confirmed) {
        this.frontofficesServices.deleteFrontOfficeReason(id).subscribe((result) => {
          if (result && !result.hasErrors){
            let index = 0;
            do {
              index = this.followupReasons.findIndex(c => c.id === id);
              if (index > -1) {
                this.followupReasons.splice(index, 1);
              }
            } while (index != -1);

            this.toastr.success('Registro Excluído.', 'Sucesso');
          }
        });
      }
    });
  }

  getAllReasons() { 
    this.frontofficesServices.getReasons().subscribe((result) => {
      if (result) {
        this.followupReasons = result;
      }
    });
  }

  InsertRequest() {
    this.frontofficesServices.insertFrontOfficeReason(this.saveFollowupReasonForm.value).subscribe((resultService) => {
      if (resultService && !resultService.hasErrors) {
        this.followupReasons.unshift(resultService.content);
        this.utilService.setFormControl(this.saveFollowupReasonForm, "description", '');
        this.toastr.success('Registro Salvo.', 'Sucesso');
      }
    });
  }

}
